import { IMapCenter } from "./common";

export interface IFace {
    FaceId: string;
    BoundingBox: any;
    Confidence: number;
    ImageId: string;
    bucket: string;
    key: string;
    collection: string;
    url: string;
    location?: IMapCenter
}
export const initialFace: IFace = {
    FaceId: '',
    BoundingBox: {},
    Confidence: 0.8,
    ImageId: '',
    bucket: '',
    key: '',
    collection: '',
    url: ''

}


// WEBPACK FOOTER //
// ./src/share/types/face.ts